module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Ultralight.31c25ebf.woff2";